<template>
  <div>
    <div  align="center" style="font-size: xxx-large " >登录页面</div>
    <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="100px">
      <el-form-item label="用户名：" prop="field101">
        <el-input v-model="formData.user" placeholder="请输入用户名：" clearable  :style="{width: '100%'}">
        </el-input>
      </el-form-item>
      <el-form-item label="密码" prop="field102">
        <el-input v-model="formData.mima" placeholder="请输入密码" clearable show-password
                  :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item size="large" align="center">
        <el-button type="primary" @click="submitForm">登录</el-button>
        <el-button @click="resetForm">重置</el-button>

      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from "../untils/request";
import * as Cookies from "core-js";

export default {
  name: "login",
  props: [],
  data() {
    return {
      formData: {
        user:null,
        mima: null,
      },
      rules: {
        user: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        mima: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
      },
      dldate:null,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    submitForm() {
      request.get("api/user/get",{
        params:{
          userName:this.formData.user,
          password:this.formData.mima
        }
      }).then(res=>{console.log(res.data),this.dldate=res.data});
      console.log(this.dldate);
      if (this.dldate){

        alert("登录成功！");

        this.$router.push({ path: '/v-htindex' });
        window.sessionStorage("usernames",this.formData.user);
        Cookies.set("username", this.formData.user, { expires: 30 });

      }else
      {

        alert("用户名密码不对")
        this.dldate=""

      }

    },
    resetForm() {
      this.$refs['elForm'].resetFields()
    },
  }


}
</script>

<style scoped>

</style>
